import script from "./AcceptMember.vue?vue&type=script&lang=ts&setup=true"
export * from "./AcceptMember.vue?vue&type=script&lang=ts&setup=true"

import "./AcceptMember.vue?vue&type=style&index=0&id=1d696666&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d696666"]])

export default __exports__